/* tslint:disable */
/* eslint-disable */
/**
 * Onbaording Buffetti Api
 * Onbaording Buffetti Api Specification
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: gianluca.stefanelli@linksmt.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { BusinessSectionFromJSON, BusinessSectionToJSON, } from './BusinessSection';
import { CommonSectionFromJSON, CommonSectionToJSON, } from './CommonSection';
import { ContoDiPagamentoSectionFromJSON, ContoDiPagamentoSectionToJSON, } from './ContoDiPagamentoSection';
import { DebtorSectionFromJSON, DebtorSectionToJSON, } from './DebtorSection';
import { LegalRappSectionFromJSON, LegalRappSectionToJSON, } from './LegalRappSection';
import { OwnerFromJSON, OwnerToJSON, } from './Owner';
import { PaginaAllegatiFromJSON, PaginaAllegatiToJSON, } from './PaginaAllegati';
import { PaymentFacilitatorSectionFromJSON, PaymentFacilitatorSectionToJSON, } from './PaymentFacilitatorSection';
import { SDSectionFromJSON, SDSectionToJSON, } from './SDSection';
import { ServizioDiPagementoSectionFromJSON, ServizioDiPagementoSectionToJSON, } from './ServizioDiPagementoSection';
import { SingatureDateFromJSON, SingatureDateToJSON, } from './SingatureDate';
import { TerminalePosSectionFromJSON, TerminalePosSectionToJSON, } from './TerminalePosSection';
import { UlterioriOneriSectionFromJSON, UlterioriOneriSectionToJSON, } from './UlterioriOneriSection';
/**
 * Check if a given object implements the ContractSchemaDto interface.
 */
export function instanceOfContractSchemaDto(value) {
    let isInstance = true;
    return isInstance;
}
export function ContractSchemaDtoFromJSON(json) {
    return ContractSchemaDtoFromJSONTyped(json, false);
}
export function ContractSchemaDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'commonSection': !exists(json, 'commonSection') ? undefined : CommonSectionFromJSON(json['commonSection']),
        'businessSection': !exists(json, 'businessSection') ? undefined : BusinessSectionFromJSON(json['businessSection']),
        'legalRappSection': !exists(json, 'legalRappSection') ? undefined : LegalRappSectionFromJSON(json['legalRappSection']),
        'ownersSections': !exists(json, 'ownersSections') ? undefined : (json['ownersSections'].map(OwnerFromJSON)),
        'contoDiPagamentoSection': !exists(json, 'contoDiPagamentoSection') ? undefined : ContoDiPagamentoSectionFromJSON(json['contoDiPagamentoSection']),
        'servizioDiPagementoSection': !exists(json, 'servizioDiPagementoSection') ? undefined : ServizioDiPagementoSectionFromJSON(json['servizioDiPagementoSection']),
        'paymentFacilitatorSection': !exists(json, 'paymentFacilitatorSection') ? undefined : PaymentFacilitatorSectionFromJSON(json['paymentFacilitatorSection']),
        'sdSection': !exists(json, 'sdSection') ? undefined : SDSectionFromJSON(json['sdSection']),
        'terminalePosSection': !exists(json, 'terminalePosSection') ? undefined : TerminalePosSectionFromJSON(json['terminalePosSection']),
        'ulterioriOneriSection': !exists(json, 'ulterioriOneriSection') ? undefined : UlterioriOneriSectionFromJSON(json['ulterioriOneriSection']),
        'debtorSection': !exists(json, 'debtorSection') ? undefined : DebtorSectionFromJSON(json['debtorSection']),
        'signatures': !exists(json, 'signatures') ? undefined : json['signatures'],
        'signaturesDate': !exists(json, 'signaturesDate') ? undefined : (json['signaturesDate'].map(SingatureDateFromJSON)),
        'signaturesCity': !exists(json, 'signaturesCity') ? undefined : json['signaturesCity'],
        'paginaAllegatiList': !exists(json, 'paginaAllegatiList') ? undefined : (json['paginaAllegatiList'].map(PaginaAllegatiFromJSON)),
    };
}
export function ContractSchemaDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'commonSection': CommonSectionToJSON(value.commonSection),
        'businessSection': BusinessSectionToJSON(value.businessSection),
        'legalRappSection': LegalRappSectionToJSON(value.legalRappSection),
        'ownersSections': value.ownersSections === undefined ? undefined : (value.ownersSections.map(OwnerToJSON)),
        'contoDiPagamentoSection': ContoDiPagamentoSectionToJSON(value.contoDiPagamentoSection),
        'servizioDiPagementoSection': ServizioDiPagementoSectionToJSON(value.servizioDiPagementoSection),
        'paymentFacilitatorSection': PaymentFacilitatorSectionToJSON(value.paymentFacilitatorSection),
        'sdSection': SDSectionToJSON(value.sdSection),
        'terminalePosSection': TerminalePosSectionToJSON(value.terminalePosSection),
        'ulterioriOneriSection': UlterioriOneriSectionToJSON(value.ulterioriOneriSection),
        'debtorSection': DebtorSectionToJSON(value.debtorSection),
        'signatures': value.signatures,
        'signaturesDate': value.signaturesDate === undefined ? undefined : (value.signaturesDate.map(SingatureDateToJSON)),
        'signaturesCity': value.signaturesCity,
        'paginaAllegatiList': value.paginaAllegatiList === undefined ? undefined : (value.paginaAllegatiList.map(PaginaAllegatiToJSON)),
    };
}
